import { action, computed, makeObservable, observable } from 'mobx';

export default class Indicator {
  state: IndicatorState = 'new';
  error = '';

  constructor() {
    makeObservable(this, {
      state: observable,
      error: observable,
      isError: computed,
      spyOnPromise: action.bound,
      setState: action.bound,
      setError: action.bound,
    });
  }

  get isError(): boolean {
    return this.state === 'error';
  }

  spyOnPromise<T = any>(promise: Promise<T>, handleError = false): Promise<T> {
    if (!promise) {
      return promise;
    }

    this.setState('processing');

    const handledPromise = promise
      .then?.(() => this.setState('processed'))
      ?.catch?.((e) => this.setState('error', e)) as any;

    return handleError ? handledPromise : promise;
  }

  setState(state: IndicatorState, error?: Error | string) {
    this.state = state;
    this.setError(error);
  }

  setError(error: any) {
    if (!error) {
      this.error = '';
    } else if (typeof error === 'string') {
      this.error = error;
    } else if (error instanceof Error) {
      this.error = error.message;
    } else {
      this.error = 'Unknown error';
    }
  }
}

type IndicatorState = 'error' | 'new' | 'processed' | 'processing';
